import { ObjectIdEmpty } from "./object-id";

export const cloneDeep = <T>(value: T): T => {
  try {
    return structuredClone(value);
  } catch {
    return JSON.parse(JSON.stringify(value)) as T;
  }
};

export const normalizeObjectId = (value: unknown, fallback: string = ObjectIdEmpty): string => {
  if (typeof value !== "string") {
    return fallback;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : fallback;
};

export const normalizeObjectIdArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return [];
  }
  const unique = new Set<string>();
  value.forEach(entry => {
    const normalized = normalizeObjectId(typeof entry === "string" ? entry : String(entry ?? ""), "");
    if (normalized && normalized !== ObjectIdEmpty) {
      unique.add(normalized);
    }
  });
  return Array.from(unique.values());
};

export const normalizeBoolean = (value: unknown): boolean => value === true;

export { ObjectIdEmpty };
